import Head from 'next/head';
import DefaultLayout from '../components/layouts/default';
import { useState } from 'react';
import useSWR, { SWRConfig } from 'swr';
import Promos from '../components/pages/Promotions/Promos/Promos';
import { useRouter } from 'next/router';
import { fetchWithCache } from '../utils';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import { getCookie } from 'cookies-next';

export async function getServerSideProps(context) {
  const data = await fetchWithCache(
    `/api/content/promotions?locale=${context.locale}&populate=deep&filters[brand][slug]=winnerz&sort=rank:asc&geo=${context?.req?.cookies?.country}&filters[$or][0][category]=sport&filters[$or][0][category]=casino`,
    {
      country: context?.req?.cookies?.country,
    },
  );

  return {
    props: {
      fallback: {
        bonuses: data,
      },
    },
  };
}

function PostsSWR({ index, locale, geo }) {
  const { success } = useSelector((state: IApplicationState) => state.authReducer.auth);

  const sortType = success ? 'sort[0]=authenticated_rank' : 'sort=rank:asc';
  const fetcher = url => fetch(url).then(r => r.json());
  const { data, error, isLoading } = useSWR(
    `/api/content/promotions?locale=${locale}&populate=deep&filters[brand][slug]=winnerz&${sortType}&geo=${geo}&filters[$or][0][category]=sport&filters[$or][0][category]=casino`,
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );

  if (error) return <div>Failed to fetch posts.</div>;
  return <Promos data={data} isLoading={isLoading}></Promos>;
}

export default function Promotions({ fallback }) {
  const [pageIndex, setPageIndex] = useState(1);
  const router = useRouter();
  const currentLocale = router.locale;
  const geo = getCookie('country');

  return (
    <>
      <Head>
        <title>{t('page.promotions.meta.title')}</title>
        <meta name="description" content={t('page.promotions.meta.description')} />
      </Head>
      <DefaultLayout>
        <div className="container-app">
          <SWRConfig value={{ fallback }}>
            <PostsSWR index={pageIndex} locale={currentLocale} geo={geo} />
          </SWRConfig>
        </div>
      </DefaultLayout>
    </>
  );
}
